import { cn, formatDate } from '@/shared/lib';
import { capitalize } from '@/shared/lib/utils/text';
import { Desktop, Skeleton, TableCell, Typography } from '@/shared/ui';

import { ITransaction } from '../model/types';
import { TransactionAmount } from './transaction-amount';
import { TransactionLabel } from './transaction-label';
import { TxsItemAvatar } from './txs-item-avatar';

interface TransactionItemProps {
  transaction: ITransaction | null;
  variant?: 'default' | 'group';
  isLoading?: boolean;
}
export const TransactionItem = ({
  transaction,
  variant = 'default',
  isLoading = false,
}: TransactionItemProps) => {
  const isGroupVariant = variant === 'group';

  return (
    <>
      <TableCell className="flex h-[72px] items-center pb-2 pt-5 font-medium">
        {isLoading ? (
          <div className="flex items-center gap-4">
            <Skeleton className="h-10 w-10 rounded-full" />
            <div>
              <Skeleton className="h-5 w-[100px]" />
              <Skeleton className="mt-1 h-5 w-[50px]" />
            </div>
          </div>
        ) : (
          transaction && (
            <>
              <TxsItemAvatar transaction={transaction} />
              <TransactionLabel transaction={transaction} />
            </>
          )
        )}
      </TableCell>
      <Desktop>
        {!isGroupVariant && (
          <TableCell className="h-[72px] pb-2 pt-5 align-top">
            {isLoading ? (
              <Skeleton className="h-5 w-[90px]" />
            ) : (
              transaction && (
                <Typography variant="16-r">
                  {formatDate(transaction.date)}
                </Typography>
              )
            )}
          </TableCell>
        )}
        <TableCell className="h-[72px] pb-2 pt-5 align-top">
          {isLoading ? (
            <Skeleton className="h-5 w-[66px]" />
          ) : (
            transaction && (
              <Typography variant="16-r">
                {capitalize(transaction.status)}
              </Typography>
            )
          )}
        </TableCell>
      </Desktop>
      <TableCell
        className={cn(
          'h-[72px] pb-2 pt-5 align-top',
          isGroupVariant && 'whitespace-nowrap',
        )}
      >
        {isLoading ? (
          <div>
            <Skeleton className="ml-auto h-5 w-[70px]" />
            <Skeleton className="ml-auto mt-1 h-5 w-[40px]" />
          </div>
        ) : (
          transaction && <TransactionAmount transaction={transaction} />
        )}
      </TableCell>
    </>
  );
};
